import AdminPushHttpService from 'dataStore/service/adminPush.service'

/**
 * Отписывает текущее устройство от Web Push и удаляет подписку на сервере.
 * Важно для PWA: без unsubscribe SW продолжит показывать уведомления при закрытом приложении.
 */
export const unsubscribeAdminPush = async (): Promise<void> => {
  if (!('serviceWorker' in navigator)) {
    return
  }

  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.getSubscription()

  if (!subscription) {
    return
  }

  const endpoint = subscription.endpoint

  // Сначала снимаем подписку в браузере/PWA, затем удаляем на сервере
  const didUnsubscribe = await subscription.unsubscribe()
  if (!didUnsubscribe) {
    throw new Error('Не удалось отписаться от Web Push на устройстве')
  }

  if (endpoint) {
    await AdminPushHttpService.deleteSubscription(endpoint)
  }
}
